var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"text-h3",attrs:{"justify":"center","align":"center","value":_vm.isLoading,"dark":"","z-index":"999999"}},[_c('div',{staticClass:"text-center ma-12"},[_c('v-progress-circular',{attrs:{"indeterminate":"","rotate":"0","size":"100","width":"14","color":"#FFF"}})],1),_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }